import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import ProfileView from '../components/topbar/profile/View/ProfileView';

// eslint-disable-next-line react/prefer-stateless-function
class ProfileLayout extends Component {
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route exact path={`${match.url}`} component={ProfileView} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  currentModule: state.general.currentModule
});

export default connect(
  mapStateToProps
)(ProfileLayout);
